import { JetView, plugins } from 'webix-jet'; // Importing JetView and plugins from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the machine register management view.
 * @extends JetView
 */
export default class machineRegisterManagement extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        return {
            type: 'wide',
            cols: [
                {
                    type: 'wide',
                    localId: 'inner:layout', // Local ID for inner layout
                    rows: [
                        {
                            view: 'toolbar', // Toolbar component
                            css: theme, // Apply theme CSS
                            elements: [
                                {
                                    css: 'user-selected', // CSS class for styling
                                    view: 'label', // Label component
                                    id: 'lblTittle', // ID for the label
                                    align: 'center', // Center alignment
                                },
                            ],
                        },
                        {
                            view: 'tabbar', // Tabbar component for navigation
                            localId: 'tabbar', // Local ID for tabbar
                            id: 'menu', // ID for the tabbar
                            height: 35, // Height of the tabbar
                            options: [
                                // Tab options
                                {
                                    id: 'machine.information', // ID for the first tab
                                    value: _('Información'), // Localized value
                                },
                                {
                                    id: 'machine.cashier.cashier', // ID for the second tab
                                    value: _('Publicidad'), // Localized value
                                },
                                {
                                    id: 'machine.reports/machine.reports.userAfilliatesReport', // ID for the third tab
                                    value: _('Reportes'), // Localized value
                                },
                                {
                                    id: 'machine.configuration/machine.configuration.securityChanges', // ID for the fourth tab
                                    value: _('Configuración'), // Localized value
                                },
                                {
                                    id: 'machine.products2/machine.products2.partnersProducts', // ID for the fifth tab
                                    value: _('Productos'), // Localized value
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with tabbar
        const cur_user = this.getParam('user', true); // Get current user parameter
        webix
            .ajax() // AJAX request to fetch client data
            .get(
                devConfig.geturlApi() + 'Client/GetClientById', // API endpoint
                'id=' + cur_user, // Query parameter
                {
                    error: function (text, data, XmlHttpRequest) {
                        // Error callback
                        webix.message('Error! '); // Display error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success callback
                        data = JSON.parse(text); // Parse response data
                        $$('lblTittle').setValue(
                            // Set value of the title label
                            "<div class='username-active'><span class='icon-user'></span><div style='font-weight: normal'>Máquina: &nbsp;</div><div>" +
                                data[0].Name + // Display client's name
                                '</div></div>',
                        );
                    },
                },
            );
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter
        );
    }
}

// FILE DOCUMENTED
